import type { ISbEventPayload } from "@storyblok/js"
import StoryblokBridge from "@storyblok/preview-bridge"
import { storyblokOptionsKey } from "~/injection-symbols"

export const useSbBridge = (id: number, cb: (event: ISbEventPayload<any>) => void) => {
  const isBridgeLoaded = !import.meta.server && typeof window.storyblokRegisterEvent !== "undefined"
  const storyId = new URL(window.location?.href).searchParams.get("_storyblok") ?? ""
  const inStory = +storyId === id

  const apiOptions = inject(storyblokOptionsKey)

  if (!isBridgeLoaded || !inStory) {
    return
  }

  window.storyblokRegisterEvent(() => {
    const sbBridge = new StoryblokBridge({
      resolveRelations: typeof apiOptions?.resolve_relations === "string" ? [apiOptions?.resolve_relations] : apiOptions?.resolve_relations,
      resolveLinks: (apiOptions?.resolve_links === "link" ? "url" : apiOptions?.resolve_links) ?? "url",
    })
    sbBridge.on(["published", "unpublished"], event => (event?.storyId === id && cb(event)))
  })
}
